import Constants from '../constants/action'

const initialState = {
  transactions: [],
  filterParams: {},
  currentPage: 1,
  prevPage: null,
  nextPage: null,
  totalPages: 0,
  totalCount: 0,
  loading: false,
  allIds: [],
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.SET_WALLET_FILTER_PARAMS:
      return {
        ...state,
        filterParams: action.filterParams,
      }

    case Constants.SET_TRANSACTIONS: {
      return {
        ...state,
        transactions: action.transactions.data,
        prevPage: action.transactions.meta.prev_page,
        nextPage: action.transactions.meta.next_page,
        currentPage: action.transactions.meta.current_page,
        totalPages: action.transactions.meta.total_pages,
        totalCount: action.transactions.meta.total_count,
        allIds: action.transactions.meta.all_ids,
        loading: false,
      }
    }

    case Constants.SET_TRANSACTIONS_FETCHING: {
      return {
        ...state,
        loading: true,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        totalCount: state.totalCount,
      }
    }

    case Constants.SET_TRANSACTIONS_ERROR:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}
